
export const DEFAULT_LOGIN_ROUTE = '/login';
export const DEFAULT_LOGOUT_ROUTE = '/logout';
export const DEFAULT_SEARCH_ROUTE = "/search"
export const DEFAULT_CACHE_SECONDS = 900;